// import React, { useState } from "react";

// const Navbar = () => {
//   const [showAuth, setShowAuth] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [showProfileMenu, setShowProfileMenu] = useState(false);
//   const [authTab, setAuthTab] = useState("login");

//   const handleLogin = (e) => {
//     e.preventDefault();
//     setIsLoggedIn(true);
//     setShowAuth(false);
//   };

//   const handleLogout = () => {
//     setIsLoggedIn(false);
//     setShowProfileMenu(false);
//   };

//   return (
//     <>
//       <style>{`
//         * { box-sizing: border-box; }
//         body { margin: 0; font-family: 'Segoe UI', sans-serif; }

//         /* NAVBAR */
//         .navbar {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 16px 50px;
//           background:#b15dc6;
//           color: #fff;
//         }

//         .logo {
//           font-size: 26px;
//           font-weight: 800;
//           letter-spacing: 1px;
//           color: #fff;
//         }

//         .nav-right {
//           display: flex;
//           align-items: center;
//           gap: 40px;
//         }

//         .nav-links {
//           display: flex;
//           gap: 28px;
//         }

//         .nav-links a {
//           color: #fff;
//           font-weight: 600;
//           text-decoration: none;
//           font-size: 15px;
//           transition: 0.3s;
//         }

//         .nav-links a:hover {
//           color: white;
//         }

//         .signin-btn {
//           padding: 9px 20px;
//           border-radius: 30px;
//           border: none;
//           cursor: pointer;
//           background: #fff;
//           color: #000;
//           font-weight: 700;
//         }

//         /* PROFILE */
//         .profile { position: relative; }

//         .profile-icon {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           cursor: pointer;
//           color: #000;
//         }

//         .profile-menu {
//           position: absolute;
//           top: 50px;
//           right: 0;
//           background: #fff;
//           color: #000;
//           border-radius: 8px;
//           width: 150px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.2);
//           overflow: hidden;
//         }

//         .profile-menu div {
//           padding: 12px;
//           font-weight: 500;
//           cursor: pointer;
//         }

//         .profile-menu div:hover {
//           background: #e2e8f0;
//         }

//         /* AUTH PANEL */
//         .auth-overlay {
//           position: fixed;
//           inset: 0;
//           background: rgba(0,0,0,0.5);
//           display: flex;
//           justify-content: flex-end;
//           z-index: 1000;
//         }

//         .auth-panel {
//           width: 380px;
//           height: 100%;
//           background: #b15dc6;
//           color: #fff;
//           padding: 30px;
//           animation: slideIn 0.4s ease forwards;
//         }

//         @keyframes slideIn {
//           from { transform: translateX(100%); }
//           to { transform: translateX(0); }
//         }

//         .auth-tabs {
//           display: flex;
//           justify-content: space-between;
//           margin-bottom: 25px;
//         }

//         .auth-tabs span {
//           cursor: pointer;
//           font-weight: 600;
//           color: #94a3b8;
//         }

//         .auth-tabs .active {
//           color: #ffffff;
//           border-bottom: 2px solid white;
//           padding-bottom: 5px;
//         }

//         .auth-panel h3 {
//           margin-bottom: 20px;
//         }

//         .auth-panel input {
//           width: 100%;
//           padding: 11px;
//           margin-bottom: 14px;
//           border-radius: 6px;
//           border: none;
//         }

//         .auth-panel button {
//           width: 100%;
//           padding: 12px;
//           border-radius: 30px;
//           border: none;
//           font-weight: bold;
//           background: linear-gradient(135deg,#38bdf8,#0ea5e9);
//           cursor: pointer;
//         }

//         .forgot {
//           text-align: right;
//           font-size: 13px;
//           color: #38bdf8;
//           cursor: pointer;
//         }
//       `}</style>

//       {/* NAVBAR */}
//       <nav className="navbar">
//         <div className="logo">Envision</div>

//         <div className="nav-right">
//           <div className="nav-links">
//             <a href="#">Admin</a>
//             <a href="#">User</a>
//             <a href="#">Manager</a>
//           </div>

//           {!isLoggedIn ? (
//             <button className="signin-btn" onClick={() => setShowAuth(true)}>
//               Sign In
//             </button>
//           ) : (
//             <div className="profile">
//               <div
//                 className="profile-icon"
//                 onClick={() => setShowProfileMenu(!showProfileMenu)}
//               >
//                 U
//               </div>

//               {showProfileMenu && (
//                 <div className="profile-menu">
//                   <div>Profile</div>
//                   <div onClick={handleLogout}>Logout</div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* AUTH PANEL */}
//       {showAuth && (
//         <div className="auth-overlay" onClick={() => setShowAuth(false)}>
//           <div className="auth-panel" onClick={(e) => e.stopPropagation()}>
//             <div className="auth-tabs">
//               <span
//                 className={authTab === "login" ? "active" : ""}
//                 onClick={() => setAuthTab("login")}
//               >
//                 Login
//               </span>
//               <span
//                 className={authTab === "signup" ? "active" : ""}
//                 onClick={() => setAuthTab("signup")}
//               >
//                 Sign Up
//               </span>
//               <span
//                 className={authTab === "forgot" ? "active" : ""}
//                 onClick={() => setAuthTab("forgot")}
//               >
//                 Forgot
//               </span>
//             </div>

//             {authTab === "login" && (
//               <form onSubmit={handleLogin}>
//                 <h3>Welcome Back</h3>
//                 <input type="email" placeholder="Email" required />
//                 <input type="password" placeholder="Password" required />
//                 <button>Login</button>
//               </form>
//             )}

//             {authTab === "signup" && (
//               <>
//                 <h3>Create Account</h3>
//                 <input placeholder="Name" />
//                 <input placeholder="Email" />
//                 <input placeholder="Password" />
//                 <button>Sign Up</button>
//               </>
//             )}

//             {authTab === "forgot" && (
//               <>
//                 <h3>Reset Password</h3>
//                 <input placeholder="Registered Email" />
//                 <button>Send Link</button>
//               </>
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Navbar;



import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logo from "../assets/images/Picture2.png";
import { useNavigate } from "react-router-dom";

const EnvisionNavbar = () => {
  const [showAuth, setShowAuth] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [authTab, setAuthTab] = useState("login");
  const [isMobileView, setIsMobileView] = useState(false);
  
  // Form state for signup
  const [signupData, setSignupData] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: ""
  });
  
  // Form state for login
  const [loginData, setLoginData] = useState({
    email: "",
    password: ""
  });
  
  // Form state for forgot password
  const [forgotEmail, setForgotEmail] = useState("");
  
  const navigate = useNavigate();

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLogin = (e) => {
  e.preventDefault();
  setIsLoggedIn(true);
  setShowAuth(false);

  setLoginData({ email: "", password: "" });

  // Redirect to /userhome
  navigate("/userhome");
};


  const handleSignup = (e) => {
    e.preventDefault();
    if (signupData.password !== signupData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    
    console.log("Signup data:", signupData);
    setIsLoggedIn(true);
    setShowAuth(false);
    
    setSignupData({
      name: "",
      email: "",
      mobile: "",
      password: "",
      confirmPassword: ""
    });
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    alert(`Password reset link sent to ${forgotEmail}`);
    setForgotEmail("");
    setAuthTab("login");
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setShowProfileMenu(false);
  };

  const handleSignupChange = (e) => {
    const { name, value } = e.target;
    setSignupData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAuthClick = () => {
    setShowAuth(true);
  };

  const handleBookDemo = () => {
    alert("Booking demo... Redirecting to demo scheduling page.");
  };

  const handleStartFreeTrial = () => {
    alert("Starting free trial... Redirecting to registration.");
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <div className="envision-navbar">
      {/* Main Navbar */}
      <nav className="envision-navbar__container">
        <div 
          className="envision-navbar__logo-container" 
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        >
          <img src={logo} alt="Envision Logo" className="envision-navbar__logo-img" />
          
        </div>

        {/* All three buttons in one row for mobile */}
        <div className="envision-navbar__right">
          {/* Book Demo Button */}
          <button 
            className="envision-navbar__button envision-navbar__button--demo"
            onClick={handleBookDemo}
          >
            {isMobileView ? 'Demo' : 'Book Demo'}
          </button>
          
          {/* Free Trial Button */}
          <button 
            className="envision-navbar__button envision-navbar__button--trial"
            onClick={handleStartFreeTrial}
          >
            {isMobileView ? 'Free Trial' : 'Start Free Trial'}
          </button>
          
          {/* Sign In / Profile Button */}
          {isLoggedIn ? (
            <div className="envision-navbar__profile">
              <div
                className="envision-navbar__profile-icon"
                onClick={() => setShowProfileMenu(!showProfileMenu)}
                aria-label="User profile"
              >
                {isMobileView ? 'U' : 'User'}
              </div>

              {showProfileMenu && (
                <div className="envision-navbar__profile-menu">
                  <div className="envision-navbar__profile-item">Dashboard</div>
                  <div className="envision-navbar__profile-item">Settings</div>
                  <div className="envision-navbar__profile-item" onClick={handleLogout}>Logout</div>
                </div>
              )}
            </div>
          ) : (
            <button 
              className="envision-navbar__button envision-navbar__button--signin"
              onClick={handleAuthClick}
            >
              {isMobileView ? 'Sign In' : 'Sign In'}
            </button>
          )}
        </div>
      </nav>

      {/* Authentication Panel */}
      {showAuth && (
        <div className="envision-navbar__auth-overlay" onClick={() => setShowAuth(false)}>
          <div className="envision-navbar__auth-panel" onClick={(e) => e.stopPropagation()}>
            <button className="envision-navbar__close-auth" onClick={() => setShowAuth(false)} aria-label="Close">
              ×
            </button>
            
            <div className="envision-navbar__auth-tabs">
              <span
                className={`envision-navbar__auth-tab ${authTab === "login" ? "envision-navbar__auth-tab--active" : ""}`}
                onClick={() => setAuthTab("login")}
              >
                Login
              </span>
              <span
                className={`envision-navbar__auth-tab ${authTab === "signup" ? "envision-navbar__auth-tab--active" : ""}`}
                onClick={() => setAuthTab("signup")}
              >
                Sign Up
              </span>
              <span
                className={`envision-navbar__auth-tab ${authTab === "forgot" ? "envision-navbar__auth-tab--active" : ""}`}
                onClick={() => setAuthTab("forgot")}
              >
                Forgot
              </span>
            </div>

            {authTab === "login" && (
              <form className="envision-navbar__auth-form" onSubmit={handleLogin}>
                <h3 className="envision-navbar__auth-title">Welcome Back</h3>
                <input 
                  type="email" 
                  name="email"
                  placeholder="Email" 
                  required 
                  className="envision-navbar__auth-input"
                  value={loginData.email}
                  onChange={handleLoginChange}
                />
                <input 
                  type="password" 
                  name="password"
                  placeholder="Password" 
                  required 
                  className="envision-navbar__auth-input"
                  value={loginData.password}
                  onChange={handleLoginChange}
                />
                <button type="submit" className="envision-navbar__auth-button">Login</button>
                <div className="envision-navbar__forgot-link" onClick={() => setAuthTab("forgot")}>
                  Forgot Password?
                </div>
              </form>
            )}

            {authTab === "signup" && (
              <form className="envision-navbar__auth-form" onSubmit={handleSignup}>
                <h3 className="envision-navbar__auth-title">Create Account</h3>
                <input 
                  type="text" 
                  name="name"
                  placeholder="Full Name" 
                  required
                  className="envision-navbar__auth-input"
                  value={signupData.name}
                  onChange={handleSignupChange}
                />
                <input 
                  type="email" 
                  name="email"
                  placeholder="Email" 
                  required
                  className="envision-navbar__auth-input"
                  value={signupData.email}
                  onChange={handleSignupChange}
                />
                <input 
                  type="tel" 
                  name="mobile"
                  placeholder="Mobile Number" 
                  required
                  className="envision-navbar__auth-input"
                  value={signupData.mobile}
                  onChange={handleSignupChange}
                />
                <input 
                  type="password" 
                  name="password"
                  placeholder="Password" 
                  required
                  className="envision-navbar__auth-input"
                  value={signupData.password}
                  onChange={handleSignupChange}
                />
                <input 
                  type="password" 
                  name="confirmPassword"
                  placeholder="Confirm Password" 
                  required
                  className="envision-navbar__auth-input"
                  value={signupData.confirmPassword}
                  onChange={handleSignupChange}
                />
                <button type="submit" className="envision-navbar__auth-button">Sign Up</button>
              </form>
            )}

            {authTab === "forgot" && (
              <form className="envision-navbar__auth-form" onSubmit={handleForgotPassword}>
                <h3 className="envision-navbar__auth-title">Reset Password</h3>
                <input 
                  type="email" 
                  placeholder="Registered Email" 
                  required
                  className="envision-navbar__auth-input"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                />
                <button type="submit" className="envision-navbar__auth-button">Send Reset Link</button>
                <div className="envision-navbar__forgot-link" onClick={() => setAuthTab("login")}>
                  Back to Login
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default EnvisionNavbar;